export const SET_CONTACT_NAME = 'SET_CONTACT_NAME'
export const SET_INITIAL_TASK_DATA = 'SET_INITIAL_TASK_DATA'
export const EDIT_TASK_DATA = 'EDIT_TASK_DATA'
export const SET_NUMBER_OF_DUE_DATE_TASKS = 'SET_NUMBER_OF_DUE_DATE_TASKS'
export const SET_NUMBER_OF_TODAY_TASKS = 'SET_NUMBER_OF_TODAY_TASKS'
export const SELECT_TASK = 'SELECT_TASK'
export const CHECK_ALL = 'CHECK_ALL'
export const SET_TASKS_SUMMARY = 'SET_TASKS_SUMMARY'
export const SET_TASK_FILTERS = 'SET_TASK_FILTERS'
export const EDIT_EVENT_DATA = 'EDIT_EVENT_DATA'
export const EDIT_EVENT_DATA_FROM_TASK = 'EDIT_EVENT_DATA_FROM_TASK'
export const SET_DATA_FOR_TASK_REPORT = 'SET_DATA_FOR_TASK_REPORT'
export const GET_NOTES_FOR_TIMELINE = 'GET_NOTES_FOR_TIMELINE'
export const CLEAR_EVENT_DATA_FROM_TASK = 'CLEAR_EVENT_DATA_FROM_TASK'
export const CLEAR_EVENT_DATA = 'CLEAR_EVENT_DATA'
export const SET_EVENT_DATA_FROM_TASK = 'SET_EVENT_DATA_FROM_TASK'
export const SET_TODAY_MEETING = 'SET_TODAY_MEETING'
export const RESET_ALL_DATA = 'RESET_ALL_DATA'
export const RESET_TASKS_FILTERS = 'RESET_TASKS_FILTERS'
export const IS_HAD_MEETING = 'IS_HAD_MEETING'
export const IS_SHARED_NOTE = 'IS_SHARED_NOTE'
export const SET_NEXT_WEEK_DATE = 'SET_NEXT_WEEK_DATE'
export const SET_LOADING = 'SET_LOADING'
export const SET_TASK_EDITING = 'SET_TASK_EDITING'
export const SET_TASK_COMPLETING = 'SET_TASK_COMPLETING'
export const GET_TASKS_FOR_DASHBOARD = 'GET_TASKS_FOR_DASHBOARD'
export const CLEAR_DASHBOARD_TASKS = 'CLEAR_DASHBOARD_TASKS'
export const GET_USER_MONTHLY_TASK_STATISTIC = 'GET_USER_MONTHLY_TASK_STATISTIC'
export const EDIT_SHARED_NOTE_DATA = 'EDIT_SHARED_NOTE_DATA'
